import React from 'react';
import { LandingPage } from './pages/LandingPage';
import { Dinero1Page } from './pages/Dinero1Page';
export function App() {
  const path = window.location.pathname;
  // atraccionabundancia.com/landing → LandingPage
  if (path.includes('/landing')) {
    return <LandingPage data-id="element-0" />;
  }
  // atraccionabundancia.com → Dinero1Page (página principal)
  return <Dinero1Page data-id="element-1" />;
}